<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="生成账单"
    :visible.sync="dialogVisible"
    width="1200px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="16%"
  >
    <BaseTable
      :height="500"
      :tableData="tableData"
      :loading="loading"
      :isPager="false"
      :isEmptyBorder="true"
      @handleSelectionChange="handleSelectionChange"
    >
    </BaseTable>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok">确 定</div>
    </span>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
import {
  supplierInvoiceData,
  customerInvoiceData,
  generateInvoiceByPayable,
  generateInvoiceByReceivable
} from '@/api/fee'
export default {
  components: { BaseTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    filterList: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: 0 // 0: 应收 1: 应付
    }
  },
  data() {
    return {
      loading: false,
      tableData: {
        fileds: [
          {
            filed: 'companyName',
            label: '客户',
            width: ''
          },
          {
            filed: 'supplierName',
            label: '供应商',
            width: ''
          },
          {
            filed: 'mblNo',
            label: '提单号',
            width: ''
          },
          {
            filed: 'containerNo',
            label: '柜号',
            width: ''
          },
          {
            filed: 'qty',
            label: '数量',
            width: ''
          },
          {
            filed: 'unitPrice',
            label: '单价',
            width: ''
          },
          {
            filed: 'totalAmount',
            label: '金额',
            width: ''
          },
          {
            filed: 'createdOn',
            label: '创建日期',
            width: ''
          },
          {
            filed: 'createdName',
            label: '创建人',
            width: ''
          }
        ],
        columns: [],
        total: 0,
        mutiCheck: true
      },
      selections: []
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.selections = []
        this.getList()
      }
    }
  },
  methods: {
    handleSelectionChange(item) {
        this.selections = item
    },
    async getList() {
      try {
        let res
        if (!this.type) {
          res = await customerInvoiceData(this.filterList)
        } else {
          res = await supplierInvoiceData(this.filterList)
        }
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    async ok() {
      try {
        if (this.selections.length === 0) {
          this.$message.error('请选择数据')
          return
        }
        let res
        this.loading = false
        if (!this.type) {
          const params = {
            companyId: this.selections[0].companyId,
            ids: this.selections.map((a) => a.id)
          }
          res = await generateInvoiceByReceivable(params)
        } else {
          const flag = Array.from(
            new Set(this.selections.map((a) => a.supplierId)),
          )
          if (flag.length > 1) {
            this.$message.error('请选择同一供应商')
            return
          }
          const params = {
            supplierId: this.selections[0].supplierId,
            ids: this.selections.map((a) => a.id)
          }
          res = await generateInvoiceByPayable(params)
        }
        this.loading = false
        if (res.success) {
          this.$message.success('生成账单成功')
          this.$emit('ok')
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
